class I18n {
  constructor() {
    this.locale = 'en'
    this.translations = null
    this.fallbacks = []

    this.fetch = this.fetch.bind(this)
    this.setLocale = this.setLocale.bind(this)
    this.setFallbacks = this.setFallbacks.bind(this)
    this.translate = this.translate.bind(this)
    this.localize = this.localize.bind(this)
    this.translatedCounter = this.translatedCounter.bind(this)
  }

  fetch(url) {
    return fetch(url).
      then(r => r.json()).
      then(data => this.translations = data)
  }

  setLocale(newLocale) {
    this.locale = newLocale
  }

  setFallbacks(fallbacks) {
    this.fallbacks = fallbacks
  }

  lookup(key) {
    const sets = (
      Array.isArray(this.translations) ?
      this.translations :
      [this.translations]
    )

    for (const set of sets) {
      const candidate = set[this.locale][key]
      if (candidate) {return candidate}
    }
  }

  translate(key, opts = {}) {
    if (!this.translations) {
      return "TRANSLATIONS NOT LOADED"
    }

    try {
      let result = this.lookup(key)

      for (const [k, v] of Object.entries(opts)) {
        const regex = new RegExp(`\\%\\{${k}\\}`, 'g')
        console.log(typeof result)
        result = result.replaceAll(regex, v)
      }

      return result
    } catch(e) {
      console.warn(e)
      return `not found: '${this.locale}:${key}'`
    }
  }

  translatedCounter(amount, singular, plural) {
    if (amount == 1) {
      return `${amount} ${this.translate(singular)}`
    } else {
      return `${amount} ${this.translate(plural)}`
    }
  }

  localize(object) {
    if (typeof object == 'object') {
      const json = JSON.stringify(object)
      const locales = [this.locale, ...this.fallbacks]
      for (const l of locales) {
        const result = object[l]
        if (result) {
          return result
        }
      }

      return `NO TRANSLATION FOR locale ${this.locale} for ${json}`
    }

    return object
  }
}

const i18n = new I18n()

export {
  i18n,
  I18n
}
